import { render, staticRenderFns } from "./TaxTypes.vue?vue&type=template&id=34b195f7"
import script from "./TaxTypes.vue?vue&type=script&lang=js"
export * from "./TaxTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b195f7')) {
      api.createRecord('34b195f7', component.options)
    } else {
      api.reload('34b195f7', component.options)
    }
    module.hot.accept("./TaxTypes.vue?vue&type=template&id=34b195f7", function () {
      api.rerender('34b195f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/TaxTypes.vue"
export default component.exports